import _compact from "lodash/compact";
import { BrowserTracing, addBreadcrumb, captureException, captureMessage, configureScope, getCurrentHub, init, reactRouterV5Instrumentation, reactRouterV6Instrumentation, withScope, withSentryReactRouterV6Routing, withSentryRouting } from '@sentry/react';
import { Route } from 'react-router-dom';
import { CompatRoute, Routes } from 'react-router-dom-v5-compat';
import { SentryUserType, Tag } from './constants';
import transactionId from './transactionId';
const Sentry = {
  addBreadcrumb,
  BrowserTracing,
  captureException,
  captureMessage,
  configureScope,
  getCurrentHub,
  init,
  reactRouterV5Instrumentation,
  reactRouterV6Instrumentation,
  withScope,
  withSentryReactRouterV6Routing,
  withSentryRouting
};
const DEFAULT_SENTRY_OPTIONS = {
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb && (breadcrumb.level === 'info' || breadcrumb.level === 'debug') && breadcrumb.category === 'console') {
      return null;
    }
    return breadcrumb;
  },
  ignoreTransactions: ['/addon/recommendation-question-flow', /^\/nav\/$/],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0
};
const getDefaultSentryOptions = ({
  apiOrigin,
  release,
  sentryDsn: dsn,
  environment,
  browserTracingOptions
}) => ({
  ...DEFAULT_SENTRY_OPTIONS,
  dsn,
  environment,
  release,
  integrations: [..._compact([apiOrigin ? new BrowserTracing({
    tracingOrigins: [apiOrigin],
    ...browserTracingOptions
  }) : false])]
});
const initSentry = (options, appName) => {
  Sentry.init(options);
  Sentry.configureScope(scope => {
    scope.setUser({
      ip_address: '{{auto}}'
    });
    scope.setTag(Tag.UserType, SentryUserType.Guest);
    scope.setTag(Tag.TransactionId, transactionId);
    if (appName) {
      scope.setTag(Tag.AppName, appName);
    }
  });
};
const initPullRequest = pr => {
  Sentry.configureScope(scope => {
    scope.setTag(Tag.PullRequest, pr);
  });
};
const SentryRoute = Sentry.withSentryRouting(Route);
const SentryCompatRoute = Sentry.withSentryRouting(CompatRoute);
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
export { Sentry, SentryCompatRoute, SentryRoute, SentryRoutes, getDefaultSentryOptions, initPullRequest, initSentry };